// Italian-only sectors/applications list for /settori-applicazioni page.
// Used only when lang === "it". Do not use in shared components.

export const settoriApplicazioniIt = [
  {
    id: "ristrutturazioni-condomini",
    slug: "ristrutturazioni-condomini",
    title: "Ristrutturazioni e Condomini",
    icon: "fa-building",
    description:
      "Ponteggi per facciate, cappotto termico, tinteggiatura esterna, manutenzione tetti e grondaie. Soluzioni per condomini occupati con minimo disagio per i residenti.",
    keywordsLine:
      "Keyword forti: ponteggi condomini Roma, ristrutturazione facciate Milano, impalcature condomini Napoli.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
  {
    id: "restauro-monumentale",
    slug: "restauro-monumentale",
    title: "Restauro Monumentale e Beni Culturali",
    icon: "fa-landmark",
    description:
      "Impalcature leggere, puntellature e ponteggi non invasivi per chiese, palazzi storici, siti vincolati Soprintendenza. Soluzioni sicure per accesso in quota senza danneggiare opere d'arte o strutture antiche.",
    keywordsLine:
      "Keyword forti: ponteggi restauro monumentale Firenze, impalcature chiese Roma, puntellature beni culturali Italia.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
  {
    id: "restauro-interno-edifici-occupati",
    slug: "restauro-interno-edifici-occupati",
    title: "Restauro Interno e Edifici Occupati",
    icon: "fa-building-user",
    description:
      "Trabattelli, scale certificate e ponteggi sospesi interni per pittura soffitti, stucchi, affreschi, manutenzione in hotel, uffici, condomini occupati. Orari flessibili, rumore ridotto, protezione ambienti per non interrompere attività.",
    keywordsLine:
      "Keyword forti: ponteggi interni edifici occupati Napoli, restauro interni Roma, trabattelli per soffitti chiese.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
  {
    id: "edilizia-commerciale-industriale",
    slug: "edilizia-commerciale-industriale",
    title: "Edilizia Commerciale e Industriale",
    icon: "fa-industry",
    description:
      "Ponteggi per capannoni, impianti, serbatoi, manutenzione industriale. Sistemi ad alta portata, resistenza vento, soluzioni per spazi confinati.",
    keywordsLine:
      "Keyword forti: ponteggi industriali Milano, impalcature capannoni Torino, ponteggi serbatoi Italia.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
  {
    id: "eventi-mostre-matrimoni",
    slug: "eventi-mostre-matrimoni",
    title: "Eventi, Mostre e Matrimoni",
    icon: "fa-calendar-check",
    description:
      "Strutture temporanee per palchi, tribune, stand, scenografie, gazebo, illuminazione. Montaggio/smontaggio ultra-rapido, portata per pubblico e attrezzature.",
    keywordsLine:
      "Keyword forti: ponteggi per eventi Roma, impalcature matrimoni Toscana, strutture temporanee fiere Milano.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
  {
    id: "cantieri-navali-marittimi",
    slug: "cantieri-navali-marittimi",
    title: "Cantieri Navali e Marittimi",
    icon: "fa-ship",
    description:
      "Accesso ponteggi per manutenzione navi, scafo, ponti, impianti marittimi. Strutture resistenti a salsedine e vento, soluzioni per spazi ristretti.",
    keywordsLine:
      "Keyword forti: ponteggi cantieri navali Genova, impalcature navali Livorno, ponteggi marittimi Italia.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
  {
    id: "infrastrutture-lavori-pubblici",
    slug: "infrastrutture-lavori-pubblici",
    title: "Infrastrutture e Lavori Pubblici",
    icon: "fa-bridge",
    description:
      "Ponteggi per ponti, viadotti, stazioni, aeroporti, ferrovie. Alta portata, permessi ANAS/Provincia, soluzioni per cantieri lineari.",
    keywordsLine:
      "Keyword forti: ponteggi infrastrutture Roma, impalcature viadotti Italia, ponteggi lavori pubblici Napoli.",
    ctaLabel: "Scopri di più",
    href: "#",
  },
]
